<template>
  <div class="app-download-container">
    <div class="download-content">
      <h1>唯泰斯</h1>
      <p>正在为您跳转至适合的下载页面...</p>
      <div v-if="loading" class="loading">
        <div class="spinner"></div>
      </div>
      <div v-else class="platform-info">
        <p>检测到您的设备：{{ deviceType }}</p>
        <p v-if="!redirectUrl">暂未获取到适合的下载链接</p>
      </div>
      <div class="manual-options" v-if="!loading && !redirectUrl">
        <h3>请选择下载方式：</h3>
        <a :href="iosDownloadUrl" class="download-btn ios-btn">
          <i class="fab fa-apple"></i>
          iOS下载
        </a>
        <a :href="androidDownloadUrl" class="download-btn android-btn">
          <i class="fab fa-android"></i>
          Android下载
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppDownload',
  data() {
    return {
      loading: true,
      deviceType: '',
      redirectUrl: '',
      iosDownloadUrl: '',
      androidDownloadUrl: '',
      config: [
        {
          dataCenterType: 0,
          publicAppId: 'usx07yqia4diqi', // 海外
          apiPath: 'https://service.hellobabysmart.com/api'
        },
        {
          dataCenterType: 1,
          publicAppId: 'cnla3t0a8tqm7t', //国内
          apiPath: 'https://service.rinoiot.com/api'
        }
      ],
      current: 1, // 默认国内
      urlObj: null
    };
  },
  created() {
    this.detectDevice();
    this.getIP();
  },
  mounted() {
    // 如果没有自动跳转，提供手动选择选项
    setTimeout(() => {
      this.loading = false;
    }, 3000);
  },
  methods: {
    // 检测设备类型
    detectDevice() {
      const userAgent = window.navigator.userAgent || '';
      
      // iOS设备检测
      if (/iPhone|iPad|iPod|Macintosh/i.test(userAgent) && 'ontouchend' in document) {
        this.deviceType = 'iOS';
      }
      // Android设备检测
      else if (userAgent.indexOf('Android') > -1 || userAgent.indexOf('Linux') > -1) {
        this.deviceType = 'Android';
      }
      // 其他设备
      else {
        this.deviceType = '其他设备';
      }
      
      console.log('检测到的设备类型:', this.deviceType);
    },
    
    // 获取IP地址确定区域
    getIP() {
      fetch('https://ipinfo.io/json')
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then((data) => {
          this.current = data && data.country === 'CN' ? 1 : 0;
          this.fetchDownloadConfig();
        })
        .catch((error) => {
          // 如果获取IP失败，默认使用国内配置
          this.current = 1;
          this.fetchDownloadConfig();
        });
    },
    
    // 获取下载配置
    async fetchDownloadConfig() {
      try {
        const response = await fetch(`${this.config[this.current].apiPath}/business-app/v1/h5/getDownloadConfig/${this.config[this.current].publicAppId}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          }
        });
        
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        
        const res = await response.json();
        this.urlObj = res.data || {};
        this.determineRedirectUrl();
      } catch (error) {
        console.error('获取下载配置失败:', error);
        this.loading = false;
        // 设置默认下载链接作为备选
        this.setDefaultUrls();
      }
    },
    
    // 确定重定向链接
    determineRedirectUrl() {
      if (!this.urlObj) return;
      
      // 根据设备类型设置不同的下载链接
      if (this.deviceType === 'iOS' && this.urlObj.appStoreUrl) {
        this.redirectUrl = this.urlObj.appStoreUrl;
        this.iosDownloadUrl = this.redirectUrl;
      } else if (this.deviceType === 'Android') {
        // 优先使用品牌商店链接
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        
        if (isMobile) {
          if (this.isHuawei() && this.urlObj.huaweiStoreUrl) {
            this.redirectUrl = this.urlObj.huaweiStoreUrl;
          } else if (this.isXiaomi() && this.urlObj.xiaomiStoreUrl) {
            this.redirectUrl = this.urlObj.xiaomiStoreUrl;
          } else if (this.isVivo() && this.urlObj.vivoStoreUrl) {
            this.redirectUrl = this.urlObj.vivoStoreUrl;
          } else if (this.isOppo() && this.urlObj.oppoStoreUrl) {
            this.redirectUrl = this.urlObj.oppoStoreUrl;
          } else if (this.current === 0 && this.urlObj.googleStoreUrl) {
            this.redirectUrl = this.urlObj.googleStoreUrl;
          } else {
            this.redirectUrl = this.urlObj.tencentStoreUrl || '';
          }
        } else {
          this.redirectUrl = this.current === 0 && this.urlObj.googleStoreUrl ? this.urlObj.googleStoreUrl : this.urlObj.tencentStoreUrl || '';
        }
        
        this.androidDownloadUrl = this.redirectUrl;
      }
      
      // 如果有重定向链接，执行跳转
      if (this.redirectUrl) {
        setTimeout(() => {
          window.location.href = this.redirectUrl;
        }, 1500);
      } else {
        this.loading = false;
        // 设置默认下载链接
        this.setDefaultUrls();
      }
    },
    
    // 设置默认下载链接
    setDefaultUrls() {
      // 设置默认的iOS和Android下载链接作为备选
      if (this.current === 0) {
        // 海外默认链接
        this.iosDownloadUrl = this.iosDownloadUrl || 'https://apps.apple.com/us/app/...';
        this.androidDownloadUrl = this.androidDownloadUrl || 'https://play.google.com/store/apps/...';
      } else {
        // 国内默认链接
        this.iosDownloadUrl = this.iosDownloadUrl || 'https://apps.apple.com/cn/app/...';
        this.androidDownloadUrl = this.androidDownloadUrl || 'https://a.app.qq.com/o/simple.jsp?id=...';
      }
    },
    
    // 设备品牌检测方法
    isHuawei() {
      const userAgentStr = navigator.userAgent.toLowerCase();
      return userAgentStr.includes('huawei') || userAgentStr.includes('honor');
    },
    
    isXiaomi() {
      const userAgentStr = navigator.userAgent.toLowerCase();
      return (
        userAgentStr.includes('mi ') ||
        userAgentStr.includes('mix ') ||
        userAgentStr.includes('redmi') ||
        userAgentStr.includes('xiaomi') ||
        userAgentStr.includes('m2012k11ac')
      );
    },
    
    isVivo() {
      const userAgentStr = navigator.userAgent.toLowerCase();
      return userAgentStr.includes('vivo');
    },
    
    isOppo() {
      const userAgentStr = navigator.userAgent.toLowerCase();
      return userAgentStr.includes('oppo') || userAgentStr.includes('pacm00') || userAgentStr.includes('pbem00');
    }
  }
};
</script>

<style scoped>
.app-download-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f5f5;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
}

.download-content {
  text-align: center;
  padding: 40px;
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  width: 100%;
}

.download-content h1 {
  color: #30b4e9;
  font-size: 36px;
  margin-bottom: 10px;
}

.download-content p {
  color: #666;
  font-size: 16px;
  margin-bottom: 30px;
}

.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #30b4e9;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.platform-info {
  margin-bottom: 30px;
}

.platform-info p {
  font-size: 18px;
  color: #333;
}

.manual-options {
  margin-top: 20px;
}

.manual-options h3 {
  color: #333;
  margin-bottom: 20px;
  font-size: 18px;
}

.download-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  padding: 12px 24px;
  margin: 10px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 500;
  transition: all 0.3s ease;
  color: white;
}

.ios-btn {
  background-color: #000000;
}

.android-btn {
  background-color: #a4c639;
}

.download-btn:hover {
  opacity: 0.9;
  transform: translateY(-2px);
}

.download-btn i {
  margin-right: 10px;
  font-size: 20px;
}
</style>